// extracted by mini-css-extract-plugin
export default {"info":"Header_info__lVGTr","user_name":"Header_user_name__Kx7co"};